import { styled } from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useTranslation } from 'next-i18next';
import ContactForm from './ContactForm';
import { Compound } from '../../../../new-lib/types/entity';

const Form = ({ compound, formRef }: { compound: Compound; formRef: any }) => {
  const { t } = useTranslation('contact');
  return (
    <Container className="form-section" ref={formRef}>
      <div className="info-background">
        <ImageWrapper
          src={'/assets/images/common/top-compound-form.png'}
          alt="contact-us"
          fill
          objectFit="cover"
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="79"
          height="20"
          viewBox="0 0 79 20"
          fill="none"
          className="nawy-logo"
        >
          <path
            d="M19.8048 0.0238389C19.9584 0.0238389 20.0899 0.00259679 20.2215 0.00259679C21.2524 0.00259679 22.3051 0.00259679 23.3359 0.00259679C23.621 0.00259679 23.7965 0.0875651 23.95 0.321228C25.8143 3.12518 27.6785 5.90789 29.5428 8.69061C29.6305 8.81806 29.7401 8.94551 29.8279 9.0942C29.8717 9.07296 29.9156 9.07296 29.9375 9.05172C29.9375 8.90303 29.9375 8.75433 29.9375 8.60564C29.9375 5.88665 29.9375 3.14642 29.9375 0.427438C29.9375 0.0875651 30.0472 -0.0186453 30.3981 0.00259679C31.5386 0.0238389 32.6791 0.00259679 33.8634 0.00259679C33.8634 5.10069 33.8634 10.1776 33.8634 15.2969C33.7318 15.2969 33.6002 15.3181 33.4467 15.3181C32.4159 15.3181 31.3631 15.3181 30.3323 15.3181C30.0472 15.3181 29.8717 15.2332 29.7182 14.9995C27.854 12.1955 25.9678 9.39159 24.0816 6.58764C24.0158 6.48143 23.9281 6.37522 23.8404 6.26901C23.7965 6.29025 23.7746 6.29025 23.7307 6.31149C23.7307 9.30663 23.7307 12.3018 23.7307 15.3394C22.3928 15.3394 21.0988 15.3394 19.7829 15.3394C19.8048 10.22 19.8048 5.14318 19.8048 0.0238389Z"
            fill="white"
          />
          <path
            d="M66.8715 4.14454C66.4109 5.37658 65.9722 6.56613 65.5336 7.75569C64.6344 10.156 63.7132 12.5776 62.814 14.9992C62.7043 15.2754 62.5947 15.3604 62.2876 15.3604C61.3884 15.3391 60.4892 15.3391 59.568 15.3604C59.239 15.3604 59.1074 15.2754 58.9978 14.978C58.3617 13.1724 57.7038 11.3668 57.0458 9.56127C57.0019 9.41257 56.9362 9.28512 56.8484 9.03021C56.7388 9.30636 56.673 9.4763 56.6291 9.62499C55.9931 11.4093 55.3351 13.1937 54.721 14.978C54.6333 15.2541 54.5017 15.3816 54.1946 15.3604C53.2735 15.3391 52.3304 15.3391 51.4092 15.3604C51.1899 15.3604 51.0364 15.3179 50.9486 15.0842C49.5669 11.4731 48.229 7.92563 46.8912 4.35696C46.8692 4.29323 46.8473 4.2295 46.8254 4.12329C46.9789 4.10205 47.0886 4.10205 47.2202 4.10205C48.2071 4.10205 49.216 4.12329 50.2029 4.10205C50.51 4.10205 50.6416 4.20826 50.7293 4.48441C51.3434 6.41744 51.9575 8.35047 52.5936 10.2623C52.6594 10.4322 52.7032 10.6021 52.791 10.857C52.8567 10.7083 52.9006 10.6234 52.9225 10.5384C53.6024 8.49916 54.2823 6.48116 54.9403 4.44193C55.028 4.16578 55.1596 4.08081 55.4448 4.08081C56.344 4.10205 57.2432 4.10205 58.1644 4.08081C58.4714 4.08081 58.603 4.18702 58.6907 4.46317C59.3268 6.45992 60.0067 8.43544 60.6646 10.4109C60.7085 10.5172 60.7524 10.6446 60.8401 10.857C61.1691 9.81617 61.4761 8.90276 61.7832 7.96811C62.178 6.77855 62.5508 5.589 62.9456 4.39944C63.0114 4.20826 63.0553 4.08081 63.3184 4.08081C64.4151 4.10205 65.5336 4.08081 66.6302 4.08081C66.7179 4.10205 66.7618 4.12329 66.8715 4.14454Z"
            fill="white"
          />
          <path
            d="M47.1105 15.297C45.8165 15.297 44.5664 15.297 43.2724 15.297C43.2724 14.9784 43.2724 14.6598 43.2724 14.3624C43.2066 14.3411 43.1627 14.3411 43.1627 14.3411C41.2107 16.2317 37.4603 15.7856 35.6399 13.4277C33.9073 11.1973 34.0827 7.45869 36.0566 5.46194C37.7674 3.74133 40.6405 3.33773 42.5705 4.56977C42.7898 4.71846 42.9872 4.8884 43.2504 5.07958C43.2504 4.73971 43.2504 4.42108 43.2504 4.0812C44.5664 4.0812 45.8384 4.0812 47.1324 4.0812C47.1105 7.86229 47.1105 11.5584 47.1105 15.297ZM38.2499 9.68911C38.2499 11.1548 39.3245 12.2169 40.794 12.2169C42.2854 12.2169 43.3382 11.1761 43.3382 9.68911C43.3382 8.20216 42.2854 7.1613 40.794 7.1613C39.3245 7.18254 38.2499 8.24465 38.2499 9.68911Z"
            fill="white"
          />
          <path
            d="M72.3765 10.9423C72.859 9.75275 73.2757 8.6694 73.7143 7.58606C74.1311 6.52395 74.5478 5.44061 75.0083 4.3785C75.0522 4.25105 75.2496 4.1236 75.3593 4.10236C76.4997 4.08112 77.6402 4.08112 78.8026 4.10236C78.8465 4.10236 78.9123 4.1236 79 4.14484C78.9562 4.29354 78.9123 4.42099 78.8465 4.54844C76.7629 9.37039 74.6574 14.2136 72.5739 19.0355C72.4423 19.3329 72.2887 19.4391 71.9598 19.4391C70.8631 19.4179 69.7885 19.4391 68.6261 19.4391C68.7796 19.078 68.9112 18.7806 69.0428 18.462C69.4814 17.4849 69.942 16.529 70.3368 15.5518C70.4245 15.3607 70.4245 15.0845 70.3368 14.8933C68.8454 11.4309 67.354 7.96842 65.8407 4.50596C65.7968 4.39975 65.7529 4.29354 65.6871 4.1236C65.8626 4.10236 65.9942 4.10236 66.1258 4.10236C67.1347 4.10236 68.1435 4.1236 69.1524 4.10236C69.5033 4.10236 69.6569 4.20857 69.7665 4.50596C70.5342 6.48147 71.3457 8.47823 72.1352 10.4537C72.2229 10.5599 72.2668 10.6874 72.3765 10.9423Z"
            fill="white"
          />
          <path
            d="M9.65019 5.97194V0.172852H0C0 0.215336 0 0.25782 0 0.300304C0 2.44575 0.767629 4.42127 2.01777 5.97194H6.1849H9.65019Z"
            fill="#7DCBC1"
          />
          <path
            d="M9.69403 5.97168V13.2365C11.339 14.5322 13.4225 15.3182 15.7035 15.3182C15.7473 15.3182 15.7912 15.3182 15.8351 15.3182V5.97168H9.69403Z"
            fill="#FF5E00"
          />
          <path
            d="M6.71129 9.09426C4.82512 8.54197 3.20213 7.43738 2.01779 5.97168H0.0438843C0.0438843 6.01416 0.0438843 6.05665 0.0438843 6.09913C0.0438843 11.1972 4.29874 15.3182 9.56248 15.3182C9.60635 15.3182 9.65021 15.3182 9.69408 15.3182V13.2577C8.33428 12.1744 7.28153 10.7511 6.71129 9.09426Z"
            fill="#015C9A"
          />
          <path
            d="M6.71126 9.09426C6.38228 8.15961 6.18489 7.13999 6.18489 6.09913C6.18489 6.05665 6.18489 6.01416 6.18489 5.97168H2.01776C3.2021 7.43738 4.82509 8.54197 6.71126 9.09426Z"
            fill="#00BDCF"
          />
          <path
            d="M13.2252 4.48499C14.4534 4.48499 15.4403 3.5291 15.4403 2.33954V0.172852H13.2252C11.997 0.172852 11.01 1.12874 11.01 2.3183C11.01 3.50786 11.997 4.48499 13.2252 4.48499Z"
            fill="#7DCBC1"
          />
          <path
            d="M9.65017 5.97168H6.18488C6.18488 6.01416 6.18488 6.05665 6.18488 6.09913C6.18488 7.13999 6.36033 8.15961 6.71125 9.09426C7.30342 10.7299 8.33424 12.1744 9.69404 13.2365V5.97168H9.65017Z"
            fill="#FF3A00"
          />
        </svg>
      </div>
      <div className="content container-fluid">
        <div className="info-side">
          <span className="contact-us">
            {t('contact_us', { ns: 'contact' })}
          </span>
          <span className="contact-title">{t('contact_title')}</span>
          <span className="contact-subtitle">{t('contact_subtitle')}</span>
        </div>
        <ContactForm compound={compound} />
      </div>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  width: 100vw;
  margin-inline-start: -50vw;
  inset-inline-start: 50%;
  min-height: 280px;
  margin-top: 48px;
  z-index: 99;
  .info-background {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50%;
    height: 280px;
    inset-inline-start: 0;
    background: linear-gradient(112deg, #112439 -10.09%, #2f679f 100%);
    z-index: -1;
    .nawy-logo {
      position: absolute;
      top: 28px;
      inset-inline-end: 28px;
    }
  }

  .content {
    display: flex;
    flex-direction: row;

    .info-side {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      line-height: 140%;
      width: 50%;
      padding-inline-end: 32px;

      .contact-us {
        color: rgba(255, 255, 255, 0.66);
        font-family: materialRegular;
        font-size: 20px;
      }
      .contact-title {
        color: white;
        font-family: materialMedium;
        font-size: 28px;
        margin-top: 16px;
      }
      .contact-subtitle {
        color: rgba(255, 255, 255, 0.8);
        font-family: materialLight;
        font-size: 18px;
        margin-top: 24px;
        max-width: 500px;
        line-height: 140%;
      }
    }
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    min-height: 280px;

    .info-background {
      position: absolute;
      top: 0;
      transform: unset;
      width: 100%;
      height: 250px;
      .nawy-logo {
        top: 16px;
        inset-inline-end: 16px;
      }
    }

    .content {
      flex-direction: column;
      line-height: 150%;
      .info-side {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        line-height: 140%;
        width: 100%;
        padding-inline-end: unset;
        padding-top: 32px;
        .contact-us {
          font-size: 18px;
        }
        .contact-title {
          font-size: 22px;
          margin-top: 8px;
        }
        .contact-subtitle {
          font-size: 14px;
          margin-top: 16px;
          width: 75%;
          margin-bottom: 32px;
        }
      }
    }
  }
`;

export default Form;
